'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var jacketSizeLabels = (0, _reactIntl.defineMessages)({
    1: {
        'id': 'formOptions.jacketSizeLabels.1',
        'defaultMessage': 'XXS'
    },
    2: {
        'id': 'formOptions.jacketSizeLabels.2',
        'defaultMessage': 'XS'
    },
    3: {
        'id': 'formOptions.jacketSizeLabels.3',
        'defaultMessage': 'S'
    },
    4: {
        'id': 'formOptions.jacketSizeLabels.4',
        'defaultMessage': 'M'
    },
    5: {
        'id': 'formOptions.jacketSizeLabels.5',
        'defaultMessage': 'L'
    },
    6: {
        'id': 'formOptions.jacketSizeLabels.6',
        'defaultMessage': 'XL'
    },
    7: {
        'id': 'formOptions.jacketSizeLabels.7',
        'defaultMessage': 'XXL'
    },
    8: {
        'id': 'formOptions.jacketSizeLabels.8',
        'defaultMessage': 'XXXL'
    },
    9: {
        'id': 'formOptions.jacketSizeLabels.9',
        'defaultMessage': 'XXXXL'
    },
    10: {
        'id': 'formOptions.jacketSizeLabels.10',
        'defaultMessage': 'XXXXXL'
    }
});

exports.default = jacketSizeLabels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/jacketSize/jacketSizeLabels.js
// module id = 1373
// module chunks = 0